import ApplicationV1Adapter from 'uplisting-frontend/adapters/application-v1';

export default class PartnerApiKeyAdapter extends ApplicationV1Adapter {}

declare module 'ember-data/types/registries/adapter' {
  interface AdapterRegistry {
    'partner-api-key': PartnerApiKeyAdapter;
  }
}
